export function splitIdList(value) {
    return (value || "")
        .split(",")
        .map((token) => token.trim())
        .filter(Boolean);
}
export function queryValues(value) {
    const values = Array.isArray(value) ? value : [value];
    return values
        .filter((item) => typeof item === "string")
        .map((item) => item.trim())
        .filter(Boolean);
}
function choices(all, names) {
    return [{ title: all, value: "" }, ...names.map((name) => ({ title: name, value: name }))];
}
function multi(key, label, noun, options, selected) {
    const items = options.filter((option) => option.value);
    const known = new Set(items.map((item) => item.value));
    const missing = selected.filter((value) => !known.has(value)).map((value) => ({ title: value, value }));
    return {
        key,
        type: "multi",
        label,
        noun,
        allLabel: options.find((option) => !option.value)?.title ?? "All",
        items: [...items, ...missing],
        selected,
    };
}
function assignment(ctx) {
    const result = [];
    if (!ctx.assignedOnly) {
        result.push(multi("assignedUser", "Assigned", "people", ctx.assigned.items, splitIdList(ctx.assigned.value)));
    }
    if (ctx.groups) {
        result.push(multi("assignedGroup", "Group", "groups", ctx.groups.items, splitIdList(ctx.groups.value)));
    }
    return result;
}
function shared(ctx) {
    const result = [
        multi("modifiedBy", "Modified By", "users", choices("All Users", ctx.modifiedBy.names), ctx.modifiedBy.value),
    ];
    if (ctx.tags.defs.length) {
        result.push({
            key: "tags",
            type: "tags",
            label: "Tags",
            tagDefs: ctx.tags.defs,
            selected: ctx.tags.selected,
            match: ctx.tags.match,
            dueFrom: ctx.tags.dueFrom,
            dueTo: ctx.tags.dueTo,
        });
    }
    if (ctx.substatus.defs.length) {
        result.push({
            key: "substatus",
            type: "substatus",
            label: "Substatus",
            columns: ctx.substatus.defs,
            selected: ctx.substatus.selected,
            match: ctx.substatus.match,
        });
    }
    return result;
}
export function paListFilters(ctx) {
    if (ctx.isProvider)
        return [];
    return [...assignment(ctx), ...shared(ctx)];
}
export function intakeListFilters(ctx) {
    const intakeOnly = [];
    if (ctx.documentTypes.names.length) {
        intakeOnly.push(multi("documentType", "Doc Type", "types", choices("All Types", ctx.documentTypes.names), ctx.documentTypes.value));
    }
    intakeOnly.push(multi("sentBy", "Sent By", "users", choices("All Users", ctx.sentBy.names), ctx.sentBy.value));
    return [...assignment(ctx), ...intakeOnly, ...shared(ctx)];
}
